import { render } from "./IndexBase.vue?vue&type=template&id=3fb61665"
import script from "./IndexBase.vue?vue&type=script&lang=js"
export * from "./IndexBase.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__